import { useWindowDimensions } from 'react-native'
import React from 'react'
import { theme } from '@linqpal/common-frontend'

const { breakpoints } = theme

export function withResponsiveExclusive (Component) {
  return ({ minWidth = 'xs', maxWidth, ...props }) => {
    const size = useWindowDimensions()

    const allowMinWidth = size.width >= (breakpoints[minWidth] || 0)
    const allowMaxWidth = maxWidth
      ? (breakpoints[maxWidth] || 0) >= size.width
      : true

    return allowMinWidth && allowMaxWidth ? <Component {...props} /> : null
  }
}
